export const CANVAS_FORMATS = [
  { id: '16:9', label: '16:9', width: 1920, height: 1080 },
  { id: '1:1', label: '1:1', width: 1080, height: 1080 },
  { id: '4:5', label: '4:5', width: 1080, height: 1350 },
  { id: '9:16', label: '9:16', width: 1080, height: 1920 },
];

export const DEFAULT_CANVAS_FORMAT_ID = CANVAS_FORMATS[0].id;

export const getCanvasFormatById = (id) => (
  CANVAS_FORMATS.find((format) => format.id === id) || CANVAS_FORMATS[0]
);
